import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditService {


  url = environment.serverAPI4 + "/api/audit"; 
  constructor( private http: HttpClient) { }

  getAuditData(entity:any,entityId:any, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/data?entity=${entity}&entityId=${entityId}&page=${Page}&size=${size}&sort=${sort}`);
	}
}
